<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark">
      <div class="container-xl">
        <div class="navbar-brand">
          <a href="/">1Click : Easy to Get Information & Connection</a>
        </div>
      </div>
    </nav>

    <div class="container pb-5">
      <div class="row pt-5">
        <div class="col-12 mb-5">
          {{ companyName }}{{$t('boothReport.description1')}}{{ showEngName }}{{$t('boothReport.description2')}}<br>
        </div>
        <div class="col-12 order-md-1">
          <h4 class="mb-3">
            {{ showName }}{{$t('boothReport.description3')}}
          </h4>
          <br>
          <p>{{$t('boothReport.description4')}}{{ reportDate }}</p>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" style="white-space: nowrap;">{{$t('boothReport.col1')}}</th>
                <th scope="col" style="white-space: nowrap;">{{$t('boothReport.col2')}}</th>
                <th scope="col" style="white-space: nowrap;">{{$t('boothReport.col3')}}</th>
                <th scope="col" style="white-space: nowrap;">{{$t('boothReport.col4')}}</th>
                <th scope="col" style="white-space: nowrap;">{{$t('boothReport.col5')}}</th>
                <th scope="col" style="white-space: nowrap;">{{$t('boothReport.col6')}}</th>
                <th scope="col" style="white-space: nowrap;">{{$t('boothReport.col7')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in reportList" :key="index">
                <th scope="row">{{ index + 1 }}</th>
                <td style="white-space: nowrap;"><p v-html="item.CREATE_DATE.toString().replace(' ','<br>')"></p></td>
                <td style="white-space: nowrap;">{{ item.COMPANY_NAME }}</td>
                <td>{{ item.COMPANY_INDUSTRY }}</td>
                <td style="white-space: nowrap;">{{ item.USER_NAME }}</td>
                <td style="white-space: nowrap;">{{ item.JOB_TITLE }}</td>
                <td style="white-space: nowrap;">{{ item.PHONE_NUMBER }}</td>
                <td style="white-space: nowrap;">{{ item.EMAIL }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="login_power">
        power by <span><img src="/images/img_logo_w.png" /></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoothReport",
  data: function () {
    return {
      companyName: "",
      showName: "",
      showEngName: "",
      contactPerson: "",
      reportDate: "",
      reportList: [],
    };
  },
  created() {
    const queryId = this.$route.params.queryId;
    this.initialLoad(queryId);
  },
  methods: {
    initialLoad: function (queryId) {
      const data = {
        QUERY_ID: queryId,
      };
      this.$ReportAPI
        .queryBoothReport(data)
        .then((res) => {
          const resultStr = res.data;
          const resultObj = JSON.parse(resultStr);
          if (resultObj.body.MESSAGE === "SUCCESS") {
            this.reportList = resultObj.body.RESULT;
            this.contactPerson = this.reportList[0].CONTACT_PERSON;
            this.companyName = this.reportList[0].COMPANY_NAME_LOCAL;
            this.showName = navigator.language.substring(0,2) === 'en' ? resultObj.body.SHOW_NAME.SHOW_ENG_NAME : resultObj.body.SHOW_NAME.SHOW_LOCAL_NAME;
            this.showEngName = resultObj.body.SHOW_NAME.SHOW_ENG_NAME;
            this.reportDate = resultObj.body.QUERY_DATE;
          } else {
            this.$alert.warningAlert(resultObj.body.MESSAGE);
          }
        })
        .catch((error) => {
          this.$alert.warningAlert(error);
          console.error(error);
        });
    },
  },
};
</script>

<style scoped></style>
